export default "__VITE_ASSET__DOzwRznx__"